/**
 * API price table: the ONE place per-token prices live (daemon usage summaries and the web
 * cost-efficiency report both read it). Prices are public list prices in USD per million tokens,
 * checked against provider pricing pages on `PRICE_TABLE_AS_OF`; they change, so every figure
 * derived from this table is an *estimate*, never a reported charge, and a model that matches no
 * entry has no estimate (unknown stays unknown). Update the entries and the date together.
 */
export const PRICE_TABLE_AS_OF = '2026-09-28';
export const MODEL_PRICES = [
    {
        match: 'claude-opus-4',
        provider: 'anthropic',
        inputPerM: 15,
        outputPerM: 75,
        cacheReadPerM: 1.5,
        cacheWritePerM: 18.75,
    },
    {
        match: 'claude-opus-4-5',
        provider: 'anthropic',
        inputPerM: 5,
        outputPerM: 25,
        cacheReadPerM: 0.5,
        cacheWritePerM: 6.25,
    },
    {
        match: 'claude-sonnet-4',
        provider: 'anthropic',
        inputPerM: 3,
        outputPerM: 15,
        cacheReadPerM: 0.3,
        cacheWritePerM: 3.75,
    },
    {
        match: 'claude-haiku-4',
        provider: 'anthropic',
        inputPerM: 1,
        outputPerM: 5,
        cacheReadPerM: 0.1,
        cacheWritePerM: 1.25,
    },
    { match: 'gpt-5', provider: 'openai', inputPerM: 1.25, outputPerM: 10, cacheReadPerM: 0.125 },
];
/** Price entry for a model id (longest prefix), or undefined when the model is unknown. */
export function priceFor(model) {
    if (!model)
        return undefined;
    const id = model.toLowerCase();
    let best;
    for (const p of MODEL_PRICES)
        if (id.startsWith(p.match) && (!best || p.match.length > best.match.length))
            best = p;
    return best;
}
/** USD estimate for tokens on one model, or undefined when the model has no table entry. */
export function estimateModelUsd(tokens, model) {
    const p = priceFor(model);
    if (!p)
        return undefined;
    return ((tokens.input * p.inputPerM +
        tokens.output * p.outputPerM +
        tokens.cacheRead * (p.cacheReadPerM ?? p.inputPerM) +
        tokens.cacheWrite * (p.cacheWritePerM ?? p.inputPerM)) /
        1_000_000);
}
//# sourceMappingURL=pricing.js.map